import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            探索你感兴趣的内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大内容板块，覆盖从入门到精通的全方位教程与指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${category.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors duration-300">
                {category.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {category.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{category.articleCount} 篇文章</span>
                <span className="text-sm text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  浏览全部 <i className="ri-arrow-right-line ml-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}